module.exports = "https://trybtryb-legacy.web.app/img/gingham-giftwrap.00160f79.webp";